import i18next from 'i18next';
import { clearCallTimeout } from '../../../core/functions/timeoutManager';

export const callRequestConfirmed = async (data, reducers) => {
  const { placeId, pointId, userId } = data;
  const { callDispatch, notificationDispatch } = reducers;

  await callDispatch({
    type: 'CALL_CONFIRMED',
    payload: {
      placeId,
      pointId,
      userId,
    },
  });

  const message = i18next.t('calls.NOTIFICATIONS.confirmed');
  const date = new Date().getTime();
  const newNotification = new CustomEvent('Notification', {
    detail: { message, type: 'success' },
  });
  clearCallTimeout('pending', userId);
  window.dispatchEvent(newNotification);

  notificationDispatch({
    type: 'UPDATE_NOTIFICATION',
    payload: {
      notificationId: 'call',
      message,
      placeId,
      pointId,
      type: 'success',
      date,
    },
  });
};
